export const geocodeAddress = async (
  city: string,
  state: string,
  zipCode: string
): Promise<{ lat: number; lng: number } | null> => {
  const query = `${city}, ${state} ${zipCode}`.trim();
  const token = process.env.REACT_APP_MAPBOX_TOKEN;

  if (!query || !token) return null;

  try {
    const res = await fetch(
      `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(query)}.json?access_token=${token}&limit=1`
    );
    const data = await res.json();
    const coords = data.features?.[0]?.center;

    if (!coords) return null;

    return { lng: coords[0], lat: coords[1] };
  } catch {
    return null;
  }
};
